import { createApi, BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { ModeratorOnboardingAction, ModeratorOnboardingResponse } from './moderator-typings';

export const MODERATOR_ONBOARDING_QUERIES = {
  moderatorOnboarding: 'moderator-onboarding',
};

/**
 * RTK Query service for the moderator onboarding endpoints on kor_nft_api.
 * Instantiate per-app with that app's authenticated baseQuery, mirroring
 * how `onboardingApiService` is wired.
 */
export const moderatorOnboardingApiService = (baseQuery: BaseQueryFn) => {
  const api = createApi({
    reducerPath: 'moderator-onboarding-api',
    baseQuery,
    tagTypes: [MODERATOR_ONBOARDING_QUERIES.moderatorOnboarding],
    endpoints: (builder) => ({
      getModeratorOnboarding: builder.query<ModeratorOnboardingResponse, { communityId: string }>({
        query: ({ communityId }) => ({
          url: `/moderator-onboarding/${communityId}`,
        }),
        providesTags: (_result, _error, { communityId }) => [
          { type: MODERATOR_ONBOARDING_QUERIES.moderatorOnboarding, id: communityId },
        ],
      }),
      patchModeratorOnboarding: builder.mutation<
        ModeratorOnboardingResponse,
        {
          communityId: string;
          action: ModeratorOnboardingAction;
          taskKey?: string;
        }
      >({
        query: ({ communityId, action, taskKey }) => ({
          url: `/moderator-onboarding/${communityId}`,
          method: 'PATCH',
          body: { action, taskKey },
        }),
        invalidatesTags: (_result, _error, { communityId }) => [
          { type: MODERATOR_ONBOARDING_QUERIES.moderatorOnboarding, id: communityId },
        ],
      }),
    }),
  });

  return api;
};
